import API from "./index";
import { ENDPOINTS } from "./endpoints";

export const listSellerRFQs = (data) =>
  API.post(ENDPOINTS.RFQS.RFQ_SEARCH, data);

export const approveRFQ = (id,data) =>
  API.put(ENDPOINTS.RFQS.RFQ_APPROVE(id),data);

export const rejectRFQ = (id) =>
  API.put(ENDPOINTS.RFQS.RFQ_REJECT(id));